export default __webpack_public_path__ + "static/media/ic_back.597f40d9.svg";